var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import { Input } from '../../form/Input';
import { DropdownWrapper, DropdownSecondaryStyled, CaretIcon, Menu, FilterWrapper, Options, OptionWrapper, OptionText, } from './styledComponents';
export var DropdownSecondary = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.defaultText, defaultText = _c === void 0 ? 'Select an option...' : _c, selectedOptionId = _a.selectedOptionId, onSelectOption = _a.onSelectOption, _d = _a.attributeToBeDisplayed, attributeToBeDisplayed = _d === void 0 ? 'text' : _d, onRemoveOption = _a.onRemoveOption, _e = _a.showFilter, showFilter = _e === void 0 ? true : _e, _f = _a.multiLined, multiLined = _f === void 0 ? false : _f, props = __rest(_a, ["options", "defaultText", "selectedOptionId", "onSelectOption", "attributeToBeDisplayed", "onRemoveOption", "showFilter", "multiLined"]);
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    var _h = useState(''), filterTerm = _h[0], setFilterTerm = _h[1];
    var selectedOption = options.find(function (option) { return option.id === selectedOptionId; });
    var filteredOptions = filterTerm
        ? options.filter(function (option) { return option.text.toLowerCase().includes(filterTerm.toLowerCase()); })
        : options;
    return (<ClickAwayListener onClickAway={function () { return setIsOpen(false); }}>
      <DropdownWrapper {...props}>
        <DropdownSecondaryStyled type="button" onClick={function (e) {
            e.preventDefault();
            setIsOpen(!isOpen);
        }} data-testid="dropdown-secondary" isOpen={isOpen} className={multiLined ? 'multilined' : ''}>
          <span>
            {selectedOption
            ? selectedOption[attributeToBeDisplayed] || selectedOption.text
            : defaultText}
          </span>
          <CaretIcon />
        </DropdownSecondaryStyled>
        {isOpen ? (<Menu>
            {showFilter && (<FilterWrapper>
                <Input autoFocus data-testid="filter-input" onChange={function (e) { return setFilterTerm(e.target.value); }} value={filterTerm}/>
              </FilterWrapper>)}
            <Options>
              {filteredOptions.map(function (option) {
                return (<OptionWrapper key={option.id}>
                    <OptionText role="option" onClick={function () {
                        setIsOpen(false);
                        onSelectOption && onSelectOption(option);
                    }} data-testid={"option-".concat(option.id)} selected={option.id === selectedOptionId} removable={!!onRemoveOption}>
                      {option[attributeToBeDisplayed] || option.text}
                    </OptionText>
                    {onRemoveOption && !option.hideRemoveIcon && (<CloseIcon data-testid={"remove-option-".concat(option.id)} onClick={function () { return onRemoveOption(option.id); }}/>)}
                  </OptionWrapper>);
            })}
            </Options>
          </Menu>) : null}
      </DropdownWrapper>
    </ClickAwayListener>);
};
